import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'

class GLOrderInfo extends BaseComponent {
	static propTypes = {
		title: PropTypes.string,
		infoArray: PropTypes.array,
		subInfoArray: PropTypes.array,
	}

	static defaultProps = {
		title: '预定信息',
		infoArray: [],
		subInfoArray: [],
	}

	_renderTitle() {
		let { title, sectionTitleTip, sectionTitleTipClickFn } = this.props
		if (_.isHasValue(title)) {
			if (_.isHasValue(sectionTitleTip)) {
				return (
					<div className={CSS.sectionTitleWrap}>
						<p className={CSS.sectionTitle}>{title}</p>
						<p
							className={CSS.sectionTitleTip}
							onClick={() => {
								if (!sectionTitleTipClickFn) return
								sectionTitleTipClickFn()
							}}
						>
							{sectionTitleTip}
						</p>
					</div>
				)
			} else {
				return <p className={CSS.sectionTitle}>{title}</p>
			}
		} else {
			return null
		}
	}
	render() {
		let { infoArray, subInfoArray } = this.props
		// subInfoArray = [{
		//     rowName: '实际入场时间',
		//     rowValue: '2020-02-20 08:30',
		// }, {
		//     rowName: '超时时长',
		//     rowValue: '1天2小时50分',
		// }]

		return (
			<div>
				<div className={CSS.section}>
					{this._renderTitle()}
					{infoArray.map((item, index) => {
						return (
							<div className={CSS.cell} key={index}>
								<p className={CSS.cellNameText}>{item.rowName || ''}</p>
								<div className={CSS.cellValueView}>
									<p className={CSS.cellValueText}>{item.rowValue || ''}</p>
									{item.rightEl}
								</div>
							</div>
						)
					})}
					{subInfoArray.length > 0 ? (
						<div className={CSS.subSection}>
							{subInfoArray.map((item, index) => {
								return (
									<div className={CSS.cell2} key={index}>
										<p>{item.rowName || ''}</p>
										<p>{item.rowValue || ''}</p>
									</div>
								)
							})}
						</div>
					) : null}
				</div>
			</div>
		)
	}
}

export default GLOrderInfo
